import { render } from "./FallbackStoreBookingButton.vue?vue&type=template&id=5de876a4"
import script from "./FallbackStoreBookingButton.vue?vue&type=script&lang=js"
export * from "./FallbackStoreBookingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__